import axios from "axios";
import { message } from "antd";
import { APP_ROUTES } from "../PageRouting/approutes";

const http = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASEURL}`,
  headers: {
    "Content-type": "application/json",
  },
});

const navigateToLogin = () => {
  sessionStorage.clear();
  window.location.href = APP_ROUTES.LOGINFORM;
};

// let isTokenExpiredHandled = false;

http.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem("access_token");
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// http.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     return new Promise((resolve, reject) => {
//       if (error.response && error.response.status === 401) {
//         if (!isTokenExpiredHandled) {
//           isTokenExpiredHandled = true;
//           message.warning({
//             content: "Your session has ended. Please log in again to continue.",
//             duration: 1.5,
//             onClose: navigateToLogin,
//           });
//         }
//       }
//       return reject(error);
//     });
//   }
// );

let isRefreshing = false;
let failedQueue = [];
let hasShownSessionExpiredMessage = false;

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = sessionStorage.getItem("refresh_token");

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const response = await http.get(
            `/oauth/new/token?refreshToken=${refreshToken}`
          );
          if (response?.data?.error === "1") {
            processQueue(response.data, null);
            isRefreshing = false;

            if (!hasShownSessionExpiredMessage) {
              hasShownSessionExpiredMessage = true;
              message.warning({
                content:
                  "Your session has ended. Please log in again to continue.",
                onClose: navigateToLogin,
              });
            }
            return Promise.reject(response.data);
          }
          const newToken = response?.data?.access_token;

          sessionStorage.setItem("access_token", newToken);
          http.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
          processQueue(null, newToken);
          isRefreshing = false;

          // Retry the original request with new token
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          return http(originalRequest);
        } catch (err) {
          processQueue(err, null);
          isRefreshing = false;

          message.warning({
            content: "Your session has ended. Please log in again to continue.",
            onClose: navigateToLogin,
          });
          return Promise.reject(err);
        }
      }

      return new Promise(function (resolve, reject) {
        failedQueue.push({
          resolve: (token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            resolve(http(originalRequest));
          },
          reject: (err) => {
            reject(err);
          },
        });
      });
    }

    return Promise.reject(error);
  }
);

export default http;
